"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = void 0;
var EventDispatcher_1 = require("./lib/gate/EventDispatcher");
var mobx_1 = require("mobx");
var interfaces_1 = require("data/interfaces");
var services_1 = require("../server/services");
var store_1 = __importDefault(require("store"));
var lodash_1 = require("lodash");
var helper_1 = require("lib/functions/helper");
var DEFAULT_PROFILE_ID = process.env.STAFF_PROFILE_ID;
var Model = (function () {
    function Model(gate, dataStore) {
        this.gate = gate;
        this.dataStore = dataStore;
        this.dispatcher = new EventDispatcher_1.EventDispatcher();
        this.validateFunctions = {};
        this.errors = {};
        this.loading = false;
        this.isLoggedIn = false;
        this.isTableUserVisible = false;
    }
    Model.prototype.test = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("PDF Model.test");
                return [2];
            });
        });
    };
    Model.prototype.addValidateFunction = function (key, f) {
        this.validateFunctions[key] = f;
    };
    Model.prototype.removeValidateFunction = function (key) {
        this.validateFunctions[key] = null;
    };
    Model.prototype.edularCoreSignIn = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var newCredentials, authService, response, profile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newCredentials = __assign(__assign({}, credentials), { slug: process.env.SLUG });
                        authService = new services_1.AuthService();
                        return [4, authService.signIn(newCredentials)];
                    case 1:
                        response = _a.sent();
                        profile = response.user.profiles[0];
                        if (profile.type !== interfaces_1.UserProfileType.Staff) {
                            throw { code: "invalid_user_type" };
                        }
                        this.user = response.user;
                        this.token = response.token;
                        this.profileId = profile.id;
                        this.setStorage(response.user, response.token, profile.id);
                        this.dispatcher.dispatch();
                        return [2, response];
                }
            });
        });
    };
    Model.prototype.getTokenFromEdularCore = function (credentials) {
        return __awaiter(this, void 0, void 0, function () {
            var authService, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        authService = new services_1.AuthService();
                        return [4, authService.getinsecureTokenF()];
                    case 1:
                        response = _a.sent();
                        console.log("@@@ response", response);
                        this.token = response.token;
                        this.profileId = String(DEFAULT_PROFILE_ID);
                        console.log("@@@ this.user, this.token, this.profileId", this.token, this.profileId);
                        this.dispatcher.dispatch();
                        return [2, response];
                }
            });
        });
    };
    Model.prototype.searchStudent = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var userService, _a, data, total, success, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        userService = new services_1.UserService(this.token, this.profileId);
                        return [4, userService.searchStudent({
                                search: search,
                                type: "student"
                            })];
                    case 1:
                        _a = _b.sent(), data = _a.data, total = _a.total, success = _a.success;
                        if (success) {
                            this.userList = data;
                            console.log("@@@ this.userList", this.userList);
                            this.dispatcher.dispatch();
                        }
                        return [2, data];
                    case 2:
                        error_1 = _b.sent();
                        alert("".concat(error_1["errorType"], " ").concat(error_1["message"]));
                        console.log("error with searchStudent", error_1);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.searchUserByRoleIdCampus = function (campus, roleIds) {
        return __awaiter(this, void 0, void 0, function () {
            var userService, _a, data, total, success, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        userService = new services_1.UserService(this.token, this.profileId);
                        return [4, userService.searchStudent({
                                campus: campus,
                                roleIds: roleIds
                            })];
                    case 1:
                        _a = _b.sent(), data = _a.data, total = _a.total, success = _a.success;
                        if (success) {
                            this.staffList = data;
                            console.log("@@@ this.staffList", this.staffList);
                            this.dispatcher.dispatch();
                        }
                        return [2, data];
                    case 2:
                        error_2 = _b.sent();
                        alert("".concat(error_2["errorType"], " ").concat(error_2["message"]));
                        console.log("error with searchUserByRoleIdCampus", error_2);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.searchEmail = function (search) {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG,
                            user_id: helper_1.MICROSERVICE_API_KEY_CREDENTIALS.userId,
                            x_profile_id: helper_1.MICROSERVICE_API_KEY_CREDENTIALS.userId,
                            search: search
                        };
                        return [4, this.gate.request("/v3/check-email", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.checkEmail = r.data;
                            console.log("student found: ", r.data);
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_3 = _a.sent();
                        console.log("error with searchEmail", error_3);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.loadSession = function () {
        var token = store_1.default.get("authToken");
        var user = store_1.default.get("user");
        var profileId = store_1.default.get("profileId");
        this.setUserToken(user, token, profileId);
    };
    Model.prototype.setUserToken = function (user, token, profileId) {
        if (user && token && profileId) {
            try {
                this.user = user;
                this.profileId = profileId;
                this.token = token;
                this.isLoggedIn = true;
            }
            catch (e) {
                store_1.default.remove("user");
            }
        }
    };
    Model.prototype.setStorage = function (user, token, profileId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    store_1.default.set("authToken", token);
                    store_1.default.set("profileId", profileId.toString());
                    store_1.default.set("user", user);
                    this.loadSession();
                    this.setUserStorage(user);
                }
                catch (e) {
                    throw e;
                }
                return [2];
            });
        });
    };
    Model.prototype.setUserStorage = function (user) {
        var profiles = (user.profiles || []).map(function (_a) {
            var id = _a.id, isAccessDisabled = _a.isAccessDisabled, active = _a.active, type = _a.type;
            return ({
                id: id,
                isAccessDisabled: isAccessDisabled,
                active: active,
                type: type
            });
        });
        var data = (0, lodash_1.pick)(user, ["id", "firstName", "lastName", "emails", "dateFormat"]);
        data.profiles = profiles;
        store_1.default.set("user", data);
    };
    Model.prototype.logout = function () {
        store_1.default.clearAll();
        this.user = null;
        this.profileId = null;
        this.token = null;
        this.isLoggedIn = false;
        location.reload();
    };
    Model.prototype.validateDefinedUserFields = function () {
        var _a = this, definedUserId = _a.definedUserId, task = _a.task;
        var result = true;
        var firstComponentWithError;
        var elements = document.getElementsByClassName("form-user-school_official");
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (element.id === undefined || element.id.trim().length === 0) {
                continue;
            }
            var value = this.json_data[element.id] || this.json_data[element.name] || "";
            if (element.className.indexOf("form-required") !== -1 &&
                !(value instanceof Date) &&
                (value === undefined || value.toString().trim().length === 0)) {
                this.errors[element.id] = "This field is required";
                result = false;
                if (firstComponentWithError === undefined) {
                    firstComponentWithError = element;
                }
            }
        }
        this.dispatcher.dispatch();
        if (firstComponentWithError) {
            firstComponentWithError.focus();
        }
        return result;
    };
    Model.prototype.validateFields = function () {
        console.log("@@@ validateFields");
        var result = true;
        var firstComponentWithError;
        var elements = document.getElementsByClassName("form-required");
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (element.id === undefined || element.id.trim().length === 0) {
                continue;
            }
            var value = this.json_data[element.id] || this.json_data[element.name] || "";
            if (!(value instanceof Date) &&
                (value === undefined || value.toString().trim().length === 0)) {
                this.errors[element.id] = "This field is required";
                result = false;
                if (firstComponentWithError === undefined) {
                    firstComponentWithError = element;
                }
            }
        }
        this.dispatcher.dispatch();
        if (firstComponentWithError) {
            firstComponentWithError.focus();
        }
        return result;
    };
    Model.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results, key, f, r;
            return __generator(this, function (_a) {
                console.log("@@@ validate");
                results = [];
                this.errors = {};
                for (key in this.validateFunctions) {
                    f = this.validateFunctions[key];
                    if (!f) {
                        continue;
                    }
                    r = f();
                    results.push(r);
                }
                if (results.includes(false) || !this.validateDefinedUserFields()) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.validateEditForm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                results = [];
                this.errors = {};
                if (!this.validateFields()) {
                    return [2, false];
                }
                return [2, true];
            });
        });
    };
    Model.prototype.getApiKeyBySlug = function () {
        return __awaiter(this, void 0, void 0, function () {
            var options, r, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/api/key/credentials", {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            this.user = r.data;
                            if (Object.keys(r.data).length > 0) {
                                this.json_data.api_key_user_id = r.data.userId;
                                this.json_data.api_key_profile_id = r.data.profileId;
                                this.json_data.profile = r.data.profile;
                                this.json_data.type = r.data.type;
                            }
                            this.dispatcher.dispatch();
                        }
                        return [2, r];
                    case 2:
                        error_4 = _a.sent();
                        console.log("some error with getApiKeyBySlug", error_4);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    Model.prototype.getDefaultCampus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id, name, code, campus;
            return __generator(this, function (_b) {
                _a = helper_1.DEFAULT_AVEDA_INFO.campus, id = _a.id, name = _a.name, code = _a.code;
                campus = "".concat(id).concat(helper_1.DELIMITER).concat(name).concat(helper_1.DELIMITER).concat(code);
                this.json_data.campus = campus;
                this.dispatcher.dispatch();
                return [2];
            });
        });
    };
    Model.prototype.getPrograms = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var campusId, options, r, programs, defaultProgramIds_1, newPrograms, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        campusId = (0, helper_1.getPartsByDelimiter)(value)[0];
                        options = {
                            slug: process.env.SLUG
                        };
                        return [4, this.gate.request("/v3/programs/".concat(campusId), {
                                data: options
                            })];
                    case 1:
                        r = _a.sent();
                        if (r.success) {
                            programs = helper_1.DEFAULT_AVEDA_INFO.campus.programs;
                            defaultProgramIds_1 = programs.map(function (_a) {
                                var id = _a.id;
                                return id;
                            });
                            newPrograms = r.data
                                .filter(function (_a) {
                                var id = _a.id;
                                return !defaultProgramIds_1.includes(id);
                            })
                                .map(function (_a) {
                                var id = _a.id, name = _a.name, code = _a.code, description = _a.description;
                                return ({
                                    name: name,
                                    value: "".concat(name)
                                });
                            });
                            this.json_data.programs = newPrograms;
                        }
                        this.dispatcher.dispatch();
                        return [2, r];
                    case 2:
                        error_5 = _a.sent();
                        console.log("some error with getPrograms", error_5);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    };
    __decorate([
        mobx_1.observable
    ], Model.prototype, "json_data", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "user", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "userList", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "staffList", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "isLoggedIn", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "isTableUserVisible", void 0);
    __decorate([
        mobx_1.observable
    ], Model.prototype, "checkEmail", void 0);
    return Model;
}());
exports.Model = Model;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kZWwuanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9Nb2RlbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDhEQUEwRDtBQUcxRCw2QkFBcUM7QUFDckMsOENBQXFEO0FBQ3JELCtDQUEyRDtBQUMzRCxnREFBeUI7QUFDekIsaUNBQTJCO0FBQzNCLCtDQUs2QjtBQUU3QixJQUFNLGtCQUFrQixHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsZ0JBQWdCLENBQUE7QUFFdkQ7SUFzQ0ksZUFBbUIsSUFBVSxFQUFTLFNBQW9CO1FBQXZDLFNBQUksR0FBSixJQUFJLENBQU07UUFBUyxjQUFTLEdBQVQsU0FBUyxDQUFXO1FBN0JuRCxlQUFVLEdBQUcsSUFBSSxpQ0FBZSxFQUFFLENBQUE7UUFDakMsc0JBQWlCLEdBQThCLEVBQUUsQ0FBQTtRQUNsRCxXQUFNLEdBQTRCLEVBQUUsQ0FBQTtRQUVwQyxZQUFPLEdBQUcsS0FBSyxDQUFBO1FBaUJmLGVBQVUsR0FBWSxLQUFLLENBQUE7UUFHM0IsdUJBQWtCLEdBQVksS0FBSyxDQUFBO0lBS21CLENBQUM7SUFFakQsb0JBQUksR0FBakI7OztnQkFDSSxPQUFPLENBQUMsR0FBRyxDQUFDLGdCQUFnQixDQUFDLENBQUE7Ozs7S0FDaEM7SUFFTSxtQ0FBbUIsR0FBMUIsVUFBMkIsR0FBVyxFQUFFLENBQVc7UUFDL0MsSUFBSSxDQUFDLGlCQUFpQixDQUFDLEdBQUcsQ0FBQyxHQUFHLENBQUMsQ0FBQTtJQUNuQyxDQUFDO0lBRU0sc0NBQXNCLEdBQTdCLFVBQThCLEdBQVc7UUFDckMsSUFBSSxDQUFDLGlCQUFpQixDQUFDLEdBQUcsQ0FBQyxHQUFHLElBQUksQ0FBQTtJQUN0QyxDQUFDO0lBRVksZ0NBQWdCLEdBQTdCLFVBQThCLFdBQWdCOzs7Ozs7d0JBQ3BDLGNBQWMseUJBQ2IsV0FBVyxLQUNkLElBQUksRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLElBQUksR0FDekIsQ0FBQTt3QkFFSyxXQUFXLEdBQUcsSUFBSSxzQkFBVyxFQUFFLENBQUE7d0JBQ3RCLFdBQU0sV0FBVyxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsRUFBQTs7d0JBQW5ELFFBQVEsR0FBRyxTQUF3Qzt3QkFDakQsT0FBTyxHQUFHLFFBQVEsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxDQUFBO3dCQUN6QyxJQUFJLE9BQU8sQ0FBQyxJQUFJLEtBQUssNEJBQWUsQ0FBQyxLQUFLLEVBQUU7NEJBQ3hDLE1BQU0sRUFBQyxJQUFJLEVBQUUsbUJBQW1CLEVBQUMsQ0FBQTt5QkFDcEM7d0JBQ0QsSUFBSSxDQUFDLElBQUksR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFBO3dCQUN6QixJQUFJLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQyxLQUFLLENBQUE7d0JBQzNCLElBQUksQ0FBQyxTQUFTLEdBQUcsT0FBTyxDQUFDLEVBQUUsQ0FBQTt3QkFDM0IsSUFBSSxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUMsSUFBSSxFQUFFLFFBQVEsQ0FBQyxLQUFLLEVBQUUsT0FBTyxDQUFDLEVBQUUsQ0FBQyxDQUFBO3dCQUMxRCxJQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsRUFBRSxDQUFBO3dCQUMxQixXQUFPLFFBQVEsRUFBQTs7OztLQUNsQjtJQUVZLHNDQUFzQixHQUFuQyxVQUFvQyxXQUFnQjs7Ozs7O3dCQUMxQyxXQUFXLEdBQUcsSUFBSSxzQkFBVyxFQUFFLENBQUE7d0JBQ3BCLFdBQU0sV0FBVyxDQUFDLGlCQUFpQixFQUFFLEVBQUE7O3dCQUFoRCxRQUFRLEdBQUcsU0FBcUM7d0JBQ3RELE9BQU8sQ0FBQyxHQUFHLENBQUMsY0FBYyxFQUFFLFFBQVEsQ0FBQyxDQUFBO3dCQUVyQyxJQUFJLENBQUMsS0FBSyxHQUFHLFFBQVEsQ0FBQyxLQUFLLENBQUE7d0JBQzNCLElBQUksQ0FBQyxTQUFTLEdBQUcsTUFBTSxDQUFDLGtCQUFrQixDQUFDLENBQUE7d0JBQzNDLE9BQU8sQ0FBQyxHQUFHLENBQUMsMkNBQTJDLEVBQUUsSUFBSSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUE7d0JBRXBGLElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLENBQUE7d0JBQzFCLFdBQU8sUUFBUSxFQUFBOzs7O0tBQ2xCO0lBRVksNkJBQWEsR0FBMUIsVUFBMkIsTUFBYzs7Ozs7Ozt3QkFFM0IsV0FBVyxHQUFHLElBQUksc0JBQVcsQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQTt3QkFDaEMsV0FBTSxXQUFXLENBQUMsYUFBYSxDQUFDO2dDQUMzRCxNQUFNLFFBQUE7Z0NBQ04sSUFBSSxFQUFFLFNBQVM7NkJBQ2xCLENBQUMsRUFBQTs7d0JBSEksS0FBeUIsU0FHN0IsRUFISyxJQUFJLFVBQUEsRUFBRSxLQUFLLFdBQUEsRUFBRSxPQUFPLGFBQUE7d0JBSTNCLElBQUksT0FBTyxFQUFFOzRCQUNULElBQUksQ0FBQyxRQUFRLEdBQUcsSUFBSSxDQUFBOzRCQUNwQixPQUFPLENBQUMsR0FBRyxDQUFDLG1CQUFtQixFQUFFLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQTs0QkFDL0MsSUFBSSxDQUFDLFVBQVUsQ0FBQyxRQUFRLEVBQUUsQ0FBQTt5QkFDN0I7d0JBQ0QsV0FBTyxJQUFJLEVBQUE7Ozt3QkFFWCxLQUFLLENBQUMsVUFBRyxPQUFLLENBQUMsV0FBVyxDQUFDLGNBQUksT0FBSyxDQUFDLFNBQVMsQ0FBQyxDQUFFLENBQUMsQ0FBQTt3QkFDbEQsT0FBTyxDQUFDLEdBQUcsQ0FBQywwQkFBMEIsRUFBRSxPQUFLLENBQUMsQ0FBQTs7Ozs7O0tBRXJEO0lBRVksd0NBQXdCLEdBQXJDLFVBQXNDLE1BQWdCLEVBQUUsT0FBaUI7Ozs7Ozs7d0JBRTNELFdBQVcsR0FBRyxJQUFJLHNCQUFXLENBQUMsSUFBSSxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUE7d0JBQ2hDLFdBQU0sV0FBVyxDQUFDLGFBQWEsQ0FBQztnQ0FDM0QsTUFBTSxRQUFBO2dDQUNOLE9BQU8sU0FBQTs2QkFDVixDQUFDLEVBQUE7O3dCQUhJLEtBQXlCLFNBRzdCLEVBSEssSUFBSSxVQUFBLEVBQUUsS0FBSyxXQUFBLEVBQUUsT0FBTyxhQUFBO3dCQUkzQixJQUFJLE9BQU8sRUFBRTs0QkFDVCxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUksQ0FBQTs0QkFDckIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxvQkFBb0IsRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUE7NEJBQ2pELElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLENBQUE7eUJBQzdCO3dCQUNELFdBQU8sSUFBSSxFQUFBOzs7d0JBRVgsS0FBSyxDQUFDLFVBQUcsT0FBSyxDQUFDLFdBQVcsQ0FBQyxjQUFJLE9BQUssQ0FBQyxTQUFTLENBQUMsQ0FBRSxDQUFDLENBQUE7d0JBQ2xELE9BQU8sQ0FBQyxHQUFHLENBQUMscUNBQXFDLEVBQUUsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUVoRTtJQUVZLDJCQUFXLEdBQXhCLFVBQXlCLE1BQWM7Ozs7Ozs7d0JBRXpCLE9BQU8sR0FBRzs0QkFDWixJQUFJLEVBQUUsT0FBTyxDQUFDLEdBQUcsQ0FBQyxJQUFJOzRCQUN0QixPQUFPLEVBQUUseUNBQWdDLENBQUMsTUFBTTs0QkFDaEQsWUFBWSxFQUFFLHlDQUFnQyxDQUFDLE1BQU07NEJBQ3JELE1BQU0sUUFBQTt5QkFDVCxDQUFBO3dCQUVPLFdBQU0sSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsaUJBQWlCLEVBQUU7Z0NBQy9DLElBQUksRUFBRSxPQUFPOzZCQUNoQixDQUFDLEVBQUE7O3dCQUZFLENBQUMsR0FBRyxTQUVOO3dCQUNGLElBQUksQ0FBQyxDQUFDLE9BQU8sRUFBRTs0QkFDWCxJQUFJLENBQUMsVUFBVSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUE7NEJBQ3hCLE9BQU8sQ0FBQyxHQUFHLENBQUMsaUJBQWlCLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFBOzRCQUN0QyxJQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsRUFBRSxDQUFBO3lCQUM3Qjt3QkFDRCxXQUFPLENBQUMsRUFBQTs7O3dCQUVSLE9BQU8sQ0FBQyxHQUFHLENBQUMsd0JBQXdCLEVBQUUsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUVuRDtJQUVNLDJCQUFXLEdBQWxCO1FBQ0ksSUFBTSxLQUFLLEdBQUcsZUFBSyxDQUFDLEdBQUcsQ0FBQyxXQUFXLENBQUMsQ0FBQTtRQUNwQyxJQUFNLElBQUksR0FBRyxlQUFLLENBQUMsR0FBRyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBQzlCLElBQU0sU0FBUyxHQUFHLGVBQUssQ0FBQyxHQUFHLENBQUMsV0FBVyxDQUFDLENBQUE7UUFDeEMsSUFBSSxDQUFDLFlBQVksQ0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLFNBQVMsQ0FBQyxDQUFBO0lBQzdDLENBQUM7SUFFTSw0QkFBWSxHQUFuQixVQUFvQixJQUFTLEVBQUUsS0FBYSxFQUFFLFNBQWM7UUFDeEQsSUFBSSxJQUFJLElBQUksS0FBSyxJQUFJLFNBQVMsRUFBRTtZQUM1QixJQUFJO2dCQUNBLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO2dCQUNoQixJQUFJLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQTtnQkFDMUIsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7Z0JBQ2xCLElBQUksQ0FBQyxVQUFVLEdBQUcsSUFBSSxDQUFBO2FBQ3pCO1lBQUMsT0FBTyxDQUFDLEVBQUU7Z0JBQ1IsZUFBSyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTthQUN2QjtTQUNKO0lBQ0wsQ0FBQztJQUVZLDBCQUFVLEdBQXZCLFVBQXdCLElBQVMsRUFBRSxLQUFhLEVBQUUsU0FBYzs7O2dCQUM1RCxJQUFJO29CQUNBLGVBQUssQ0FBQyxHQUFHLENBQUMsV0FBVyxFQUFFLEtBQUssQ0FBQyxDQUFBO29CQUM3QixlQUFLLENBQUMsR0FBRyxDQUFDLFdBQVcsRUFBRSxTQUFTLENBQUMsUUFBUSxFQUFFLENBQUMsQ0FBQTtvQkFDNUMsZUFBSyxDQUFDLEdBQUcsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDLENBQUE7b0JBQ3ZCLElBQUksQ0FBQyxXQUFXLEVBQUUsQ0FBQTtvQkFDbEIsSUFBSSxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQTtpQkFDNUI7Z0JBQUMsT0FBTyxDQUFDLEVBQUU7b0JBQ1IsTUFBTSxDQUFDLENBQUE7aUJBQ1Y7Ozs7S0FDSjtJQUVNLDhCQUFjLEdBQXJCLFVBQXNCLElBQUk7UUFDdEIsSUFBTSxRQUFRLEdBQUcsQ0FBQyxJQUFJLENBQUMsUUFBUSxJQUFJLEVBQUUsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFDLEVBQW9DO2dCQUFuQyxFQUFFLFFBQUEsRUFBRSxnQkFBZ0Isc0JBQUEsRUFBRSxNQUFNLFlBQUEsRUFBRSxJQUFJLFVBQUE7WUFBTSxPQUFBLENBQUM7Z0JBQ2xGLEVBQUUsSUFBQTtnQkFDRixnQkFBZ0Isa0JBQUE7Z0JBQ2hCLE1BQU0sUUFBQTtnQkFDTixJQUFJLE1BQUE7YUFDUCxDQUFDO1FBTG1GLENBS25GLENBQUMsQ0FBQTtRQUNILElBQU0sSUFBSSxHQUFRLElBQUEsYUFBSSxFQUFDLElBQUksRUFBRSxDQUFDLElBQUksRUFBRSxXQUFXLEVBQUUsVUFBVSxFQUFFLFFBQVEsRUFBRSxZQUFZLENBQUMsQ0FBQyxDQUFBO1FBQ3JGLElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFBO1FBQ3hCLGVBQUssQ0FBQyxHQUFHLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQyxDQUFBO0lBQzNCLENBQUM7SUFFTSxzQkFBTSxHQUFiO1FBQ0ksZUFBSyxDQUFDLFFBQVEsRUFBRSxDQUFBO1FBQ2hCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFBO1FBQ2hCLElBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFBO1FBQ3JCLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFBO1FBQ2pCLElBQUksQ0FBQyxVQUFVLEdBQUcsS0FBSyxDQUFBO1FBQ3ZCLFFBQVEsQ0FBQyxNQUFNLEVBQUUsQ0FBQTtJQUNyQixDQUFDO0lBRU8seUNBQXlCLEdBQWpDO1FBQ1UsSUFBQSxLQUF3QixJQUFJLEVBQTNCLGFBQWEsbUJBQUEsRUFBRSxJQUFJLFVBQVEsQ0FBQTtRQUNsQyxJQUFJLE1BQU0sR0FBWSxJQUFJLENBQUE7UUFDMUIsSUFBSSx1QkFBdUIsQ0FBQTtRQUMzQixJQUFNLFFBQVEsR0FBUSxRQUFRLENBQUMsc0JBQXNCLENBQUMsMkJBQTJCLENBQUMsQ0FBQTtRQUNsRixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtZQUN0QyxJQUFNLE9BQU8sR0FBRyxRQUFRLENBQUMsQ0FBQyxDQUFDLENBQUE7WUFDM0IsSUFBSSxPQUFPLENBQUMsRUFBRSxLQUFLLFNBQVMsSUFBSSxPQUFPLENBQUMsRUFBRSxDQUFDLElBQUksRUFBRSxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7Z0JBQzVELFNBQVE7YUFDWDtZQUNELElBQU0sS0FBSyxHQUFRLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxJQUFJLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQTtZQUNuRixJQUNJLE9BQU8sQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLGVBQWUsQ0FBQyxLQUFLLENBQUMsQ0FBQztnQkFDakQsQ0FBQyxDQUFDLEtBQUssWUFBWSxJQUFJLENBQUM7Z0JBQ3hCLENBQUMsS0FBSyxLQUFLLFNBQVMsSUFBSSxLQUFLLENBQUMsUUFBUSxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUMsTUFBTSxLQUFLLENBQUMsQ0FBQyxFQUMvRDtnQkFDRSxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsR0FBRyx3QkFBd0IsQ0FBQTtnQkFDbEQsTUFBTSxHQUFHLEtBQUssQ0FBQTtnQkFDZCxJQUFJLHVCQUF1QixLQUFLLFNBQVMsRUFBRTtvQkFDdkMsdUJBQXVCLEdBQUcsT0FBTyxDQUFBO2lCQUNwQzthQUNKO1NBQ0o7UUFDRCxJQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsRUFBRSxDQUFBO1FBQzFCLElBQUksdUJBQXVCLEVBQUU7WUFDekIsdUJBQXVCLENBQUMsS0FBSyxFQUFFLENBQUE7U0FDbEM7UUFDRCxPQUFPLE1BQU0sQ0FBQTtJQUNqQixDQUFDO0lBRU8sOEJBQWMsR0FBdEI7UUFDSSxPQUFPLENBQUMsR0FBRyxDQUFDLG9CQUFvQixDQUFDLENBQUE7UUFDakMsSUFBSSxNQUFNLEdBQVksSUFBSSxDQUFBO1FBQzFCLElBQUksdUJBQXVCLENBQUE7UUFDM0IsSUFBTSxRQUFRLEdBQVEsUUFBUSxDQUFDLHNCQUFzQixDQUFDLGVBQWUsQ0FBQyxDQUFBO1FBQ3RFLEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxRQUFRLENBQUMsTUFBTSxFQUFFLENBQUMsRUFBRSxFQUFFO1lBQ3RDLElBQU0sT0FBTyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQTtZQUMzQixJQUFJLE9BQU8sQ0FBQyxFQUFFLEtBQUssU0FBUyxJQUFJLE9BQU8sQ0FBQyxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtnQkFDNUQsU0FBUTthQUNYO1lBQ0QsSUFBTSxLQUFLLEdBQVEsSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsRUFBRSxDQUFDLElBQUksSUFBSSxDQUFDLFNBQVMsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxDQUFBO1lBQ25GLElBQ0ksQ0FBQyxDQUFDLEtBQUssWUFBWSxJQUFJLENBQUM7Z0JBQ3hCLENBQUMsS0FBSyxLQUFLLFNBQVMsSUFBSSxLQUFLLENBQUMsUUFBUSxFQUFFLENBQUMsSUFBSSxFQUFFLENBQUMsTUFBTSxLQUFLLENBQUMsQ0FBQyxFQUMvRDtnQkFDRSxJQUFJLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxFQUFFLENBQUMsR0FBRyx3QkFBd0IsQ0FBQTtnQkFDbEQsTUFBTSxHQUFHLEtBQUssQ0FBQTtnQkFDZCxJQUFJLHVCQUF1QixLQUFLLFNBQVMsRUFBRTtvQkFDdkMsdUJBQXVCLEdBQUcsT0FBTyxDQUFBO2lCQUNwQzthQUNKO1NBQ0o7UUFDRCxJQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsRUFBRSxDQUFBO1FBQzFCLElBQUksdUJBQXVCLEVBQUU7WUFDekIsdUJBQXVCLENBQUMsS0FBSyxFQUFFLENBQUE7U0FDbEM7UUFDRCxPQUFPLE1BQU0sQ0FBQTtJQUNqQixDQUFDO0lBRVksd0JBQVEsR0FBckI7Ozs7Z0JBQ0ksT0FBTyxDQUFDLEdBQUcsQ0FBQyxjQUFjLENBQUMsQ0FBQTtnQkFDdkIsT0FBTyxHQUFHLEVBQUUsQ0FBQTtnQkFDaEIsSUFBSSxDQUFDLE1BQU0sR0FBRyxFQUFFLENBQUE7Z0JBQ2hCLEtBQVMsR0FBRyxJQUFJLElBQUksQ0FBQyxpQkFBaUIsRUFBRTtvQkFDOUIsQ0FBQyxHQUFHLElBQUksQ0FBQyxpQkFBaUIsQ0FBQyxHQUFHLENBQUMsQ0FBQTtvQkFDckMsSUFBSSxDQUFDLENBQUMsRUFBRTt3QkFDSixTQUFRO3FCQUNYO29CQUNLLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQTtvQkFDYixPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFBO2lCQUNsQjtnQkFFRCxJQUFJLE9BQU8sQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMseUJBQXlCLEVBQUUsRUFBRTtvQkFDOUQsV0FBTyxLQUFLLEVBQUE7aUJBQ2Y7Z0JBQ0QsV0FBTyxJQUFJLEVBQUE7OztLQUNkO0lBRVksZ0NBQWdCLEdBQTdCOzs7O2dCQUNRLE9BQU8sR0FBRyxFQUFFLENBQUE7Z0JBQ2hCLElBQUksQ0FBQyxNQUFNLEdBQUcsRUFBRSxDQUFBO2dCQUNoQixJQUFJLENBQUMsSUFBSSxDQUFDLGNBQWMsRUFBRSxFQUFFO29CQUN4QixXQUFPLEtBQUssRUFBQTtpQkFDZjtnQkFDRCxXQUFPLElBQUksRUFBQTs7O0tBQ2Q7SUFFWSwrQkFBZSxHQUE1Qjs7Ozs7Ozt3QkFFYyxPQUFPLEdBQUc7NEJBQ1osSUFBSSxFQUFFLE9BQU8sQ0FBQyxHQUFHLENBQUMsSUFBSTt5QkFDekIsQ0FBQTt3QkFFTyxXQUFNLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLHlCQUF5QixFQUFFO2dDQUN2RCxJQUFJLEVBQUUsT0FBTzs2QkFDaEIsQ0FBQyxFQUFBOzt3QkFGRSxDQUFDLEdBQUcsU0FFTjt3QkFDRixJQUFJLENBQUMsQ0FBQyxPQUFPLEVBQUU7NEJBRVgsSUFBSSxDQUFDLElBQUksR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFBOzRCQUNsQixJQUFJLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUU7Z0NBQ2hDLElBQUksQ0FBQyxTQUFTLENBQUMsZUFBZSxHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFBO2dDQUM5QyxJQUFJLENBQUMsU0FBUyxDQUFDLGtCQUFrQixHQUFHLENBQUMsQ0FBQyxJQUFJLENBQUMsU0FBUyxDQUFBO2dDQUNwRCxJQUFJLENBQUMsU0FBUyxDQUFDLE9BQU8sR0FBRyxDQUFDLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQTtnQ0FDdkMsSUFBSSxDQUFDLFNBQVMsQ0FBQyxJQUFJLEdBQUcsQ0FBQyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUE7NkJBQ3BDOzRCQUNELElBQUksQ0FBQyxVQUFVLENBQUMsUUFBUSxFQUFFLENBQUE7eUJBQzdCO3dCQUNELFdBQU8sQ0FBQyxFQUFBOzs7d0JBRVIsT0FBTyxDQUFDLEdBQUcsQ0FBQyxpQ0FBaUMsRUFBRSxPQUFLLENBQUMsQ0FBQTs7Ozs7O0tBRTVEO0lBRVksZ0NBQWdCLEdBQTdCOzs7O2dCQUVRLEtBQ0EsMkJBQWtCLE9BRE0sRUFBZixFQUFFLFFBQUEsRUFBRSxJQUFJLFVBQUEsRUFBRSxJQUFJLFVBQUEsQ0FDTDtnQkFDaEIsTUFBTSxHQUFHLFVBQUcsRUFBRSxTQUFHLGtCQUFTLFNBQUcsSUFBSSxTQUFHLGtCQUFTLFNBQUcsSUFBSSxDQUFFLENBQUE7Z0JBQzVELElBQUksQ0FBQyxTQUFTLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtnQkFDOUIsSUFBSSxDQUFDLFVBQVUsQ0FBQyxRQUFRLEVBQUUsQ0FBQTs7OztLQUM3QjtJQUVZLDJCQUFXLEdBQXhCLFVBQXlCLEtBQWE7Ozs7Ozs7d0JBRXZCLFFBQVEsR0FBSSxJQUFBLDRCQUFtQixFQUFDLEtBQUssQ0FBQyxHQUE5QixDQUE4Qjt3QkFDdkMsT0FBTyxHQUFHOzRCQUNaLElBQUksRUFBRSxPQUFPLENBQUMsR0FBRyxDQUFDLElBQUk7eUJBQ3pCLENBQUE7d0JBQ08sV0FBTSxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyx1QkFBZ0IsUUFBUSxDQUFFLEVBQUU7Z0NBQ3hELElBQUksRUFBRSxPQUFPOzZCQUNoQixDQUFDLEVBQUE7O3dCQUZFLENBQUMsR0FBRyxTQUVOO3dCQUNGLElBQUksQ0FBQyxDQUFDLE9BQU8sRUFBRTs0QkFFRSxRQUFRLEdBQ2pCLDJCQUFrQixnQkFERCxDQUNDOzRCQUNoQixzQkFBb0IsUUFBUSxDQUFDLEdBQUcsQ0FBQyxVQUFDLEVBQUk7b0NBQUgsRUFBRSxRQUFBO2dDQUFNLE9BQUEsRUFBRTs0QkFBRixDQUFFLENBQUMsQ0FBQTs0QkFDOUMsV0FBVyxHQUFHLENBQUMsQ0FBQyxJQUFJO2lDQUNyQixNQUFNLENBQUMsVUFBQyxFQUFJO29DQUFILEVBQUUsUUFBQTtnQ0FBTSxPQUFBLENBQUMsbUJBQWlCLENBQUMsUUFBUSxDQUFDLEVBQUUsQ0FBQzs0QkFBL0IsQ0FBK0IsQ0FBQztpQ0FDakQsR0FBRyxDQUFDLFVBQUMsRUFBNkI7b0NBQTVCLEVBQUUsUUFBQSxFQUFFLElBQUksVUFBQSxFQUFFLElBQUksVUFBQSxFQUFFLFdBQVcsaUJBQUE7Z0NBQU0sT0FBQSxDQUFDO29DQUNyQyxJQUFJLE1BQUE7b0NBQ0osS0FBSyxFQUFFLFVBQUcsSUFBSSxDQUFFO2lDQUNuQixDQUFDOzRCQUhzQyxDQUd0QyxDQUFDLENBQUE7NEJBQ1AsSUFBSSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsV0FBVyxDQUFBO3lCQUN4Qzt3QkFDRCxJQUFJLENBQUMsVUFBVSxDQUFDLFFBQVEsRUFBRSxDQUFBO3dCQUMxQixXQUFPLENBQUMsRUFBQTs7O3dCQUVSLE9BQU8sQ0FBQyxHQUFHLENBQUMsNkJBQTZCLEVBQUUsT0FBSyxDQUFDLENBQUE7Ozs7OztLQUV4RDtJQTFWRDtRQURDLGlCQUFVOzRDQUNtQjtJQW1COUI7UUFEQyxpQkFBVTt1Q0FDa0I7SUFHN0I7UUFEQyxpQkFBVTsyQ0FDVztJQUd0QjtRQURDLGlCQUFVOzRDQUNZO0lBR3ZCO1FBREMsaUJBQVU7NkNBQ3VCO0lBR2xDO1FBREMsaUJBQVU7cURBQytCO0lBRzFDO1FBREMsaUJBQVU7NkNBQ1c7SUF5VDFCLFlBQUM7Q0FBQSxBQTdWRCxJQTZWQztBQTdWWSxzQkFBSyJ9